import type { ComponentProps } from 'react'

import type { Badge } from '@/components/ui/badge'
import type { TProdutoStatusEnum, TProdutoTipoLegendaStatusEnum, TTipoProdutoEnum } from '@/types/produto'

type TConfiguracaoPorStatusProduto = Record<
  TProdutoTipoLegendaStatusEnum,
  { variant: ComponentProps<typeof Badge>['variant'] }
>

type TDescricaoPorTipoProduto = Record<TTipoProdutoEnum, Record<TProdutoStatusEnum, string>>

export const configuracaoPorStatusProduto: TConfiguracaoPorStatusProduto = {
  ReservadoPorProposta: { variant: 'warning' },
  Disponivel: { variant: 'success' },
  Indisponivel: { variant: 'destructive' },
  ReservadoPeloVendedor: { variant: 'warning-dark' },
} as const

export const descricaoPorTipoProduto: TDescricaoPorTipoProduto = {
  Acessorio: { Disponivel: 'Disponível', Indisponivel: 'Indisponível', Reservada: 'Reservado', Vendida: 'Vendido' },
  Lote: { Disponivel: 'Disponível', Indisponivel: 'Indisponível', Reservada: 'Reservado', Vendida: 'Vendido' },
  Unidade: { Disponivel: 'Disponível', Indisponivel: 'Indisponível', Reservada: 'Reservada', Vendida: 'Vendida' },
  VagaPadrao: { Disponivel: 'Disponível', Indisponivel: 'Indisponível', Reservada: 'Reservada', Vendida: 'Vendida' },
} as const
